import 'bootstrap/dist/css/bootstrap.css';
import 'intro.js/minified/introjs.min.css';
import 'pretty-checkbox/dist/pretty-checkbox.min.css';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { PersistGate } from 'redux-persist/integration/react';
import I18n from 'redux-i18n';

import { getLocale } from 'actions/language/selectors';
import { initApp } from 'actions/ui/init/initActions';
import { ViewportProvider } from 'helpers/ViewportContext';
import { translations } from 'language/translations';
import withAnalytics from 'lib/analytics';
import configureStore from 'lib/configureStore';
import history from 'lib/history';
import registerServiceWorker from 'lib/registerServiceWorker';

import AccessDenied from 'components/pages/AccessDenied/AccessDeniedContainer';
import AppLayout from 'components/AppLayoutContainer';
import NotFound from 'components/pages/NotFound/NotFoundComponent';

// Make redux initial store
const { store, persistor } = configureStore({}, history);

// Actual Rendering Function
const renderApp = () =>
  render(
    <Provider id="app" store={store}>
      <PersistGate persistor={persistor}>
        {(bootstrapped) =>
          !bootstrapped ? (
            'Loading...'
          ) : (
            <I18n
              translations={translations}
              initialLang={getLocale(store.getState())}
            >
              <ViewportProvider>
                <ConnectedRouter history={history}>
                  <Switch>
                    <Route
                      path="/:lang/NotFound"
                      component={withAnalytics(NotFound)}
                    />
                    <Route
                      path="/:lang/AccessDenied"
                      component={withAnalytics(AccessDenied)}
                    />
                    <Route path="/:lang/:client" component={AppLayout} />
                    <Redirect exact from="/" to="/en/NotFound" />
                    <Redirect exact from="/:lang" to="/:lang/NotFound" />
                  </Switch>
                </ConnectedRouter>
              </ViewportProvider>
            </I18n>
          )
        }
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );
renderApp();
store.dispatch(initApp());

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js